/**
 * iter127 — tiny CSV exporter used by the analytics tables.
 * No dependency, no server round-trip, respects Excel's quirk of needing a
 * BOM to decode UTF-8 correctly and a leading `\r\n` between rows.
 *
 *   exportRowsToCsv({
 *     filename: 'product-insights-2026-09-17.csv',
 *     columns: [{ key: 'product_name', label: 'Product' }, ...],
 *     rows: [...]
 *   })
 *
 * `columns[i].format(value, row)` (optional) lets a caller pre-format numbers
 * or dates without polluting the row objects.
 */
function escapeCell(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  // Fields containing quotes, commas or newlines must be double-quoted and
  // any embedded double-quote must itself be doubled up.
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function exportRowsToCsv({ filename, columns, rows }) {
  const header = columns.map((c) => escapeCell(c.label)).join(',');
  const body = (rows || []).map((r) => columns.map((c) => {
    const raw = c.key ? r[c.key] : undefined;
    const val = c.format ? c.format(raw, r) : raw;
    return escapeCell(val);
  }).join(',')).join('\r\n');
  // \ufeff = UTF-8 BOM, keeps Excel from mangling ₹ / non-ASCII product names.
  const csv = '\ufeff' + header + '\r\n' + body + '\r\n';
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `export-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

export default exportRowsToCsv;
